import captureSentryException from '../../../tracking/sentry/captureSentryException';
import ApiClient from '../../../lib/ApiClient/ApiClient';

const actions = {
  storeEvent({ commit, state }, payload) {
    const { events } = state;
    events.push(payload);
    commit('SET_EVENTS', events);
  },
  emptyEvents({ commit }) {
    commit('SET_EVENTS', []);
  },
  async sendStoredEvents({ dispatch, state }, payload) {
    try {
      const postPromises = [];
      const primaryIdentifier = String(payload.account_id);
      const sessionId = payload.rails_session_id;
      const endpoint = process.env.BEHAVIOR_TRACKING_URL;
      const { events } = state;
      while (events.length > 0) {
        const event = events.pop();
        event.primary_identifier = primaryIdentifier;
        event.additional_identifiers = {
          ...event.additional_identifiers,
          session_id: sessionId,
        };
        postPromises.push(ApiClient.post(endpoint, event));
      }
      await Promise.all(postPromises);
    } catch (e) {
      captureSentryException(e);
    } finally {
      // Potential improvement: implement retry logic for failed event calls
      // instead of emptying regardless
      dispatch('emptyEvents');
    }
  },
};

export default actions;
